import { render, staticRenderFns } from "./annualEducationPlan.vue?vue&type=template&id=97bba3ac"
import script from "./annualEducationPlan.vue?vue&type=script&lang=js"
export * from "./annualEducationPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97bba3ac')) {
      api.createRecord('97bba3ac', component.options)
    } else {
      api.reload('97bba3ac', component.options)
    }
    module.hot.accept("./annualEducationPlan.vue?vue&type=template&id=97bba3ac", function () {
      api.rerender('97bba3ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/annualEducationPlan.vue"
export default component.exports